/** @format */

import { Auth0ChainConfig, ProxyPathConfig, Store } from './environment-common-config.interface';

export interface ThirdParty {
  affirm?: {
    store: Record<string, Store>;
  };

  afterPay?: {
    scriptConfig: string;
    script: string;
  };

  auth0: Record<string, Auth0ChainConfig>;

  bnpl?: {
    baseUrl: string;
    scriptSrc: string;
  };

  bv?: {
    store: {
      dsg: Store;
      gg: Store;
      pl?: Store;
      g3: Store;
      dsgQA: Store;
      ggQA?: Store;
      plQA?: Store;
      calia?: Store;
      vrst?: Store;
      caliaQA?: Store;
      vrstQA?: Store;
      g3QA?: Store;
      mjQA?: Store;
    };
    socialApi?: {
      fullUrl: string;
      proxyConfig: {
        proxy: ProxyPathConfig;
        baseUrl: string;
        akamai?: {
          path: string;
        };
      };
      dataSourceIdReveal: string;
      brandDomains: {
        dsg: string;
      };
    };
    api?: {
      proxyConfig?: {
        proxy: ProxyPathConfig;
        baseUrl: string;
        akamai?: {
          path: string;
          seoPath: string;
        };
      };
      reviewsUrl?: string;
      revewSummaryApiVersion: string;
      statisticsUrl?: string;
      feedbackUrl?: string;
      baseDomain?: string | { dsg: string; gg: string; pl: string; g3: string };
      summarisedFeaturesUrl?: string;
      reviewAISummaryUrl?: string;
      authenticDiscoveryApiUrl?: string;
      instances?: { dsg: string; gg: string; pl: string; g3: string };
      socialApi?: {
        dataSourceIdReveal: string;
        brandDomains: {
          dsg: string;
        };
        ProxyConfig?: {
          baseUrl: string;
          proxy: ProxyPathConfig;
        };
      };
    };
  };

  googlePlaces?: {
    script: string;
  };

  honeycomb?: {
    apiKey: string;
    serviceName: string;
  };

  i3?: {
    store: {
      calia: {
        enabled: boolean;
        baseUrl: string;
      };
      dsg: {
        enabled: boolean;
        baseUrl: string;
      };
      gg: {
        enabled: boolean;
        baseUrl: string;
      };
      pl?: unknown;
      g3?: unknown;
    };
  };

  images?: {
    scene7proxy: {
      marketing: string;
      marketingContent: string;
    };
    flags: {
      useProxy: boolean;
      useNetstorage?: boolean;
    };
  };

  payments?: {
    adyenCreditCard?: {
      config: string;
      script: string;
    };
    independencePay: {
      cart?: {
        fallback: {
          script: string;
          config: string;
        };
        primary?: {
          script: string;
          config: string;
        };
      };
      payments: {
        primary: {
          config: string;
          script: string;
        };
        v2: {
          config: string;
          script: string;
        };
        fallback: {
          config: string;
          script: string;
        };
        config?: string;
        script?: string;
      };
    };
    fallbackScriptConfig?: string;
    fallbackScript?: string;
    scriptConfig?: string;
    script?: string;
  };

  paypal?: {
    store: {
      dsg: {
        baseUrl: string;
        clientIdParam: string;
        additionalParams: string;
      };
      calia?: unknown;
      gg: unknown;
      pl?: unknown;
      g3?: unknown;
      vrst?: unknown;
      vrstQA?: unknown;
    };
  };

  radar?: {
    script: string;
    stylesheet: string;
  };

  scene7?: {
    baseConfig?: {
      baseUrl: string;
      imageDirectory: string;
      closedCaption?: string;
      videoDirectory: string;
      cdn: string;
      css: string;
      secureBaseUrl: string;
      queryString: string;
      sdkUrl: string;
      viewerUrl: string;
    };
    url: string;
    suffix: string;
    timeout?: number;
  };

  searchDex?: {
    gatewayUrlProxy: ProxyPathConfig;
    store: Record<string, { baseUrl: string }>;
  };

  soasta?: {
    enabled: boolean;
    store: {
      calia: string;
      dsg: string;
      gg: string;
      vrst: string;
      g3: string;
      pl?: string;
    };
  };

  stylitics?: {
    store: {
      dsg: {
        script: string;
      };
      gg: unknown;
      pl: {
        script: string;
      };
      g3: unknown;
    };
  };

  tealium?: {
    enabled: boolean;
    store: {
      dsg: Store;
      gg: Store;
      pl?: Store;
      g3?: Store;
      calia?: Store;
      vrst?: Store;
      sm?: Store;
      plf?: Store;
    };
  };

  trueFit?: {
    baseUrl: string;
  };
}
